import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Scheme_Allot_All_Afso from './Scheme_Allot_All_Afso';
import Box from '@mui/material/Box';

const fetchTransactionData = async (params) => {
    //console.log("Fetching with params:", JSON.stringify(params));
    const response = await fetch(`${process.env.REACT_APP_URL_SALE}/Sale/Scheme_Sale_All_District`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch transaction data');
    }

    const data = await response.json();
    //console.log("API Response:", data);
    return data;
};



const handleDownload = () => {
    const tableSelect = document.getElementById('distReport'); // Select table by ID
    if (!tableSelect) return;

    const dataType = 'application/vnd.ms-excel';
    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    downloadLink.download = 'sale_dist.xls';
    downloadLink.click();
    document.body.removeChild(downloadLink);
};



const DetailedTransaction = ({ dist_code, month, year }) => {
    const [allotList, setAllotList] = useState([]);
    const [schemeList, setSchemeList] = useState([]);
    const [commodityList, setCommodityList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContent, setRenderContent] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [dataTime, setDataTime] = useState(null);
    const detailsRef = useRef(null);

    const handleDistClick = (month, year, dist_code) => {
        setRenderContent(null);
        setTimeout(() => {
            setRenderContent(
                <Scheme_Allot_All_Afso month={month} year={year} dist_code={dist_code} />
            );
        }, 10);
    };

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const params = {
                dist_code: dist_code,
                month: month,
                year: year
            };

            try {
                const response_data = await fetchTransactionData(params);
                setTabHeading(response_data.heading);

                if (response_data && response_data.data) {
                    setAllotList(response_data.data);

                    // Extract unique schemes
                    const schemes = response_data.data.reduce((acc, item) => {
                        item.schemelist?.forEach(scheme => {
                            if (!acc.some(existing => existing.scheme_id === scheme.scheme_id)) {
                                acc.push(scheme);
                            }
                        });
                        return acc;
                    }, []);

                    // Extract unique commodities
                    const uniqueCommodities = response_data.data.reduce((acc, item) => {
                        item.commodityList?.forEach(commodity => {
                            const isExisting = acc.some(existing =>
                                existing.comm_id === commodity.comm_id
                            );
                            if (!isExisting) {
                                acc.push({
                                    comm_id: commodity.comm_id,
                                    comm_name_en: commodity.comm_name_en
                                });
                            }
                        });
                        return acc;
                    }, []);

                    setSchemeList(schemes);
                    setCommodityList(uniqueCommodities);
                    if (response_data.data.length > 0) {
                        const dTimeItem = response_data.data.find(item => item.data_time || item.DATA_TIME);
                        let dTime = dTimeItem ? (dTimeItem.data_time || dTimeItem.DATA_TIME) : "";
                        if (dTime) {
                            try {
                                const date = new Date(dTime);
                                const day = String(date.getDate()).padStart(2, '0');
                                const monthName = String(date.getMonth() + 1).padStart(2, '0');
                                const yearVal = date.getFullYear();
                                let hours = date.getHours();
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                const seconds = String(date.getSeconds()).padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                hours = hours % 12 || 12;
                                const strHours = String(hours).padStart(2, '0');
                                dTime = `${day}-${monthName}-${yearVal} ${strHours}:${minutes}:${seconds} ${ampm}`;
                            } catch (e) {
                                dTime = dTime.replace('T', ' ').substring(0, 19);
                            }
                        }
                        setDataTime(dTime);
                    }
                    // console.log("Schemes:", schemes);
                    // console.log("Commodities:", uniqueCommodities);
                } else {
                    setSchemeList([]);
                    setAllotList([]);
                    setCommodityList([]);
                }
            } catch (error) {
                //  console.error('Error fetching data:', error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [dist_code, month, year]);

    useEffect(() => {
        if (!loading && !error && allotList.length > 0 && detailsRef.current) {
            detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, allotList]);

    const getCommodityData = (item, schemeId, commodityId, dataType) => {
        const commodity = item.commodityList?.find(c =>
            c.scheme_id === schemeId && c.comm_id === commodityId
        );
        return commodity ? (commodity[dataType] || 0) : 0;
    };

    const calculateTotals = () => {
        const totals = {};

        schemeList.forEach(scheme => {
            totals[scheme.scheme_id] = {};
            commodityList.forEach(commodity => {
                totals[scheme.scheme_id][commodity.comm_id] = {
                    allotment: 0,
                    sale: 0
                };
            });
        });

        allotList.forEach(item => {
            schemeList.forEach(scheme => {
                commodityList.forEach(commodity => {
                    const allotment = getCommodityData(item, scheme.scheme_id, commodity.comm_id, 'allomtQty');
                    const sale = getCommodityData(item, scheme.scheme_id, commodity.comm_id, 'saleQty');

                    totals[scheme.scheme_id][commodity.comm_id].allotment += parseFloat(allotment) || 0;
                    totals[scheme.scheme_id][commodity.comm_id].sale += parseFloat(sale) || 0;
                });
            });
        });

        return totals;
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? allotList.length : parseInt(value, 10));
        setPage(0);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" style={{ textAlign: 'center' }}>Internal Error: {error.message}</div>;
    }

    if (allotList.length === 0) {
        return <div className="mainhead" style={{ textAlign: 'center' }}>No data found</div>;
    }

    const totals = calculateTotals();

    return (
        <>
            <br />
            <br />
            <div style={{
                overflowX: 'auto',
                overflowY: 'auto',
                maxHeight: '700px', // Adjust height as needed
                maxWidth: '100%', // Ensures the div doesn't exceed the parent container
                margin: '0 auto' // Center the table
            }}>
                <table
                    align="center"
                    border="1"
                    cellPadding="6"
                    id='distReport'
                    style={{
                        minWidth: '100%',
                        width: 'max-content' // Ensures table takes its natural width
                    }}
                >
                    <thead

                        style={{
                            position: 'sticky',
                            top: 0,
                            background: '#fff', // Solid background to prevent content overlap
                            zIndex: 10 // Ensure headers stay above body content
                        }}
                    >
                        {tabHeading && (
                            <tr className="tableheader">
                                <th colSpan={2 + (schemeList.length * 2) + (schemeList.length * commodityList.length * 2)}>
                                    {tabHeading}
                                </th>
                            </tr>
                        )}

                        <tr className="tableheader">
                            <th rowSpan={3}>Sl.No</th>
                            <th rowSpan={3}>District</th>
                            <th colSpan={schemeList.length * 2}>Total Cards & Units</th>
                            <th colSpan={schemeList.length * commodityList.length}>Allotment (Kgs)</th>
                            <th colSpan={schemeList.length * commodityList.length}>Sale (Kgs)</th>
                        </tr>

                        <tr className="tableheader">
                            {schemeList.map((scheme, index) => (
                                <th key={`cards-${index}`} colSpan={2}>{scheme.scheme_short_name}</th>
                            ))}
                            {schemeList.map((scheme, index) => (
                                <th key={`allot-${index}`} colSpan={commodityList.length}>{scheme.scheme_short_name}</th>
                            ))}
                            {schemeList.map((scheme, index) => (
                                <th key={`sale-${index}`} colSpan={commodityList.length}>{scheme.scheme_short_name}</th>
                            ))}
                        </tr>

                        <tr className="tableheader">
                            {schemeList.map((scheme, index) => (
                                <React.Fragment key={`cardunit-${index}`}>
                                    <th>Cards</th>
                                    <th>Units</th>
                                </React.Fragment>
                            ))}
                            {schemeList.map((scheme, schemeIndex) =>
                                commodityList.map((commodity, commodityIndex) => (
                                    <th key={`allot-comm-${schemeIndex}-${commodityIndex}`}>
                                        {commodity.comm_name_en}
                                    </th>
                                ))
                            )}
                            {schemeList.map((scheme, schemeIndex) =>
                                commodityList.map((commodity, commodityIndex) => (
                                    <th key={`sale-comm-${schemeIndex}-${commodityIndex}`}>
                                        {commodity.comm_name_en}
                                    </th>
                                ))
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {allotList.map((item, index) => (
                            <tr key={`${item.dist_code}-${index}`}>
                                <td style={{ textAlign: 'center' }}>
                                    {rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}
                                </td>
                                <td style={{ textAlign: 'left', paddingLeft: '10px' }}>
                                    <a
                                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                        onClick={() => handleDistClick(month, year, item.dist_code)}
                                    >
                                        {item.distName}
                                    </a>
                                </td>
                                {schemeList.map((scheme, i) => {
                                    const schemeData = item.schemelist?.find(s => s.scheme_id === scheme.scheme_id);
                                    return (
                                        <React.Fragment key={`cardunit-data-${i}`}>
                                            <td style={{ textAlign: 'right' }}>
                                                {schemeData?.cards ? (schemeData.cards) : '0'}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {schemeData?.units ? (schemeData.units) : '0'}
                                            </td>
                                        </React.Fragment>
                                    );
                                })}
                                {schemeList.map((scheme, schemeIndex) =>
                                    commodityList.map((commodity, commodityIndex) => {
                                        const quantity = getCommodityData(item, scheme.scheme_id, commodity.comm_id, 'allomtQty');
                                        return (
                                            <td key={`allot-data-${schemeIndex}-${commodityIndex}`} style={{ textAlign: 'right' }}>
                                                {quantity > 0 ? parseFloat(quantity).toFixed(2) : '0.00'}
                                            </td>
                                        );
                                    })
                                )}
                                {schemeList.map((scheme, schemeIndex) =>
                                    commodityList.map((commodity, commodityIndex) => {
                                        const quantity = getCommodityData(item, scheme.scheme_id, commodity.comm_id, 'saleQty');
                                        return (
                                            <td key={`sale-data-${schemeIndex}-${commodityIndex}`} style={{ textAlign: 'right' }}>
                                                {quantity > 0 ? parseFloat(quantity).toFixed(2) : '0.00'}
                                            </td>
                                        );
                                    })
                                )}
                            </tr>
                        ))}
                        <tr className="tableheader" style={{ fontWeight: 'bold' }}>
                            <td colSpan={2} style={{ textAlign: 'center' }}>Total</td>
                            {schemeList.map((scheme, i) => {
                                const totalCards = allotList.reduce((sum, item) => {
                                    const schemeData = item.schemelist?.find(s => s.scheme_id === scheme.scheme_id);
                                    return sum + (parseFloat(schemeData?.cards) || 0);
                                }, 0);
                                const totalUnits = allotList.reduce((sum, item) => {
                                    const schemeData = item.schemelist?.find(s => s.scheme_id === scheme.scheme_id);
                                    return sum + (parseFloat(schemeData?.units) || 0);
                                }, 0);
                                return (
                                    <React.Fragment key={`total-cardunit-${i}`}>
                                        <td style={{ textAlign: 'center' }}>
                                            {totalCards > 0 ? totalCards.toLocaleString() : '0'}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {totalUnits > 0 ? totalUnits.toLocaleString() : '0'}
                                        </td>
                                    </React.Fragment>
                                );
                            })}
                            {schemeList.map((scheme, schemeIndex) =>
                                commodityList.map((commodity, commodityIndex) => (
                                    <td key={`total-allot-${schemeIndex}-${commodityIndex}`} style={{ textAlign: 'center' }}>
                                        {totals[scheme.scheme_id][commodity.comm_id].allotment > 0
                                            ? totals[scheme.scheme_id][commodity.comm_id].allotment.toFixed(2)
                                            : '0.00'}
                                    </td>
                                ))
                            )}
                            {schemeList.map((scheme, schemeIndex) =>
                                commodityList.map((commodity, commodityIndex) => (
                                    <td key={`total-sale-${schemeIndex}-${commodityIndex}`} style={{ textAlign: 'center' }}>
                                        {totals[scheme.scheme_id][commodity.comm_id].sale > 0
                                            ? totals[scheme.scheme_id][commodity.comm_id].sale.toFixed(2)
                                            : '0.00'}
                                    </td>
                                ))
                            )}
                        </tr>

                    </tbody>
                </table>



            </div>
            {dataTime && (
                <div style={{ textAlign: 'right', width: '100%', margin: '10px auto 0', fontWeight: 'bold' }}>
                    Last Refresh Time: {dataTime}
                </div>
            )}

            {allotList.length > 10 && (
                <div style={{ textAlign: 'center', margin: '20px' }}>
                    {/* Add pagination controls here if needed */}
                </div>
            )}
            <div align="center"><button type="button" class="button button2" onClick={handleDownload}>Data to Excel</button>
            </div>
            <br />
            <br />
            <br />
            <div ref={detailsRef}>{renderContent}</div>
        </>
    );
};

export default DetailedTransaction;